import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import PropTypes from "prop-types";

import { getCourses } from "../../actions/course";

import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import LiveMentorsSearchInput from "../layout/Mentors/LiveMentorsSearchInput";
import LiveMentorsFeature from "../layout/Mentors/LiveMentorsFeature";
import MentorMiniStream from "../layout/Mentors/MentorMiniStream";

const LiveOnIMEMentors = ({
  auth: { user, channelid, jobtitle, location, verified },
  isAuthenticated,
  course: { courses },
  getCourses,
}) => {
  const [view, setView] = useState({
    streams: true,
    courses: false,
  });
  const [showAuthentication, setShowAuthentication] = useState(true);

  useEffect(() => {
    getCourses();
  }, [getCourses]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNavRed />}
      {!isAuthenticated && <LoggedOutNav />}
      <div className="flex-all-content-fixed">
        <LiveMentorsSearchInput />
        <LiveMentorsFeature />
        <div className="active-view-live-ime">
          <div
            onClick={() => setView({ streams: true, courses: false })}
            className="section-title red"
          >
            Streams
            {view.streams && <i className="far fa-check-circle mx-5 red"></i>}
          </div>
          <div
            onClick={() => setView({ streams: false, courses: true })}
            className="section-title red"
          >
            Courses
            {view.courses && <i className="far fa-check-circle mx-5 red"></i>}
          </div>
        </div>
        {view.streams && (
          <div>
            <section className="results">
              <div className="live-results">
                <div className="results-section-items red">
                  <p className="results-p">
                    Your
                    <span className="white mx-5">Subscriptions</span>
                  </p>
                </div>
              </div>
              <hr className="background-red" />
              <p className="empty-content-alt red">No Subscriptions</p>
              {/* <div className="created-content">
                <Link to="/liveonime/mentors/stream_id">
                  <MentorMiniStream />
                </Link>
                <Link to="/liveonime/mentors/stream_id">
                  <MentorMiniStream />
                </Link>
                <Link to="/liveonime/mentors/stream_id">
                  <MentorMiniStream />
                </Link>
              </div> */}
            </section>
            <section className="results">
              <div className="live-results">
                <div className="results-section-items red">
                  <p className="results-p">
                    Mentor
                    <span className="white mx-5">Streams</span>
                  </p>
                </div>
              </div>
              <hr className="background-red" />
              <p className="empty-content-alt red">No Streams</p>
              {/* <div className="created-content">
                <Link to="/liveonime/mentors/stream_id">
                  <MentorMiniStream />
                </Link>
                <Link to="/liveonime/mentors/stream_id">
                  <MentorMiniStream />
                </Link>
                <Link to="/liveonime/mentors/stream_id">
                  <MentorMiniStream />
                </Link>
              </div> */}
            </section>
          </div>
        )}
        {view.courses && (
          <div>
            <section className="results">
              <div className="live-results">
                <div className="results-section-items red">
                  <p className="results-p">
                    Your
                    <span className="white mx-5">Subscriptions</span>
                  </p>
                </div>
              </div>
              <hr className="background-red" />
              <p className="empty-content-alt red">No Subscriptions</p>
              {/* <div className="created-content">
                <Link to="/liveonime/mentors/stream_id">
                  <MentorMiniStream />
                </Link>
                <Link to="/liveonime/mentors/stream_id">
                  <MentorMiniStream />
                </Link>
                <Link to="/liveonime/mentors/stream_id">
                  <MentorMiniStream />
                </Link>
              </div> */}
            </section>
            <section className="results">
              <div className="live-results">
                <div className="results-section-items red">
                  <p className="results-p">
                    Mentor
                    <span className="white mx-5">Courses</span>
                  </p>
                </div>
              </div>
              <hr className="background-red" />
              {courses && courses.length === 0 && (
                <p className="empty-content-alt red">No Courses</p>
              )}
              {courses &&
                courses.length > 0 &&
                courses.map((course) => {
                  return (
                    <div className="created-content">
                      <MentorMiniStream course={course} key={course._id} />
                    </div>
                  );
                })}
            </section>
          </div>
        )}
      </div>
    </Fragment>
  );
};

LiveOnIMEMentors.propTypes = {
  getCourses: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  course: state.course,
});

export default connect(mapStateToProps, { getCourses })(LiveOnIMEMentors);
